<template>
  <div class="lxm-panel panel"
       :style="panelStyle">
    <template v-for="row in rows">
      <a class="panel-block is-clearfix"
         :class="{ 'panel-block--has-tag' : row.value && row.value.type === 'tags' && row.value.data.length > 0, 'panel-block--loading' : row.loading }"
         target="_blank"
         :style="panelBlockStyle"
         @click="rowClicked(row)">
        <span v-if="row.key.iconClass"
              class="lxm-panel__icon panel-icon"
              :class="row.key.iconClass"></span>
        <span class="lxm-panel__left-text">{{ row.key.text }}</span>
        <template v-if="row.value">
          <span class="lxm-panel__value is-pulled-right has-text-right" :style="spanStyle(row)">
            <template v-if="row.value.type === 'tags'">
              <template v-for="tag in row.value.data">
                <span class="lxm-panel__tag">
                  <lxm-tag :color="tag.color"
                           :text="tag.text"
                           :to="tag.to"></lxm-tag>
                </span>
              </template>
            </template>
            <template v-else-if="row.value.type === 'text' || row.value.data">
              {{ row.value.data }}
              <img v-if="row.value.arrow" class="lxm-panel__right-arrow" src="../../images/main/contact/panel-right-arrow.png" />
            </template>
            <template v-else>
              {{ valueContent(row) }}
            </template>
          </span>
        </template>
      </a>
    </template>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  panel-font-size = siz(14)
  .lxm-panel
    font-size: panel-font-size
    &.panel
      border: 0
      background-color: white
      padding: 0 spacing
      &:not(:last-child)
        margin-bottom: spacing
    .panel-block
      padding: spacing 0
      line-height: 1
      &.panel-block--has-tag
        padding-bottom: spacing - spacing-small
      &.panel-block--loading
        color: grey
      &:not(:last-child)
        border-bottom: 1px solid white-line
      &:hover
        background: white
  .lxm-panel__left-text
    height: panel-font-size
    vertical-align: middle
  .lxm-panel__value
    color: grey-dark
    display: inline-block
    width: siz(205)
  .lxm-panel__tag
    display: inline-flex
    margin-left: siz(5)
    margin-bottom: spacing-small
  .lxm-panel__right-arrow
    width: siz(7)
    height: siz(12)
    vertical-align: top
    margin-left: siz(2)

  .lxm-panel__icon
    display: inline-block
    width: siz(14)
    height: siz(14)
    line-height: 1
    background-repeat: no-repeat
    background-position: center center
    vertical-align: middle
    margin-right: siz(6)
  .lxm-panel__icon--org
    background-image: url('../../images/main/contact/org.png')
    background-size: siz(14) siz(12.5)
  .lxm-panel__icon--category
    background-image: url('../../images/main/contact/category.png')
    background-size: siz(11) siz(10)
  .lxm-panel__icon--tag
    background-image: url('../../images/main/contact/tag.png')
    background-size: siz(13) siz(13)
  .lxm-panel__icon--remark
    background-image: url('../../images/main/contact/remark.png')
    background-size: siz(11) siz(11)
  .lxm-panel__icon--attachment
    background-image: url('../../images/main/contact/attachment.png')
    background-size: siz(12) siz(11)
  .lxm-panel__icon--size
    background-image: url('../../images/main/contact/size.png')
    background-size: siz(10) siz(10)
  .lxm-panel__icon--chat
    background-image: url('../../images/main/dashboard/menu-chat.png')
    background-size: siz(12) siz(14)
  .lxm-panel__icon--check-in
    background-image: url('../../images/main/dashboard/menu-check-in.png')
    background-size: siz(12) siz(12)
  .lxm-panel__icon--power-off
    background-image: url('../../images/main/dashboard/menu-power-off.png')
    background-size: siz(13) siz(14.5)
  .lxm-panel__icon--question
    background-image: url('../../images/main/dashboard/menu-question.png')
    background-size: siz(13) siz(13)
</style>

<script>
  import LxmTag from './LxmTag.vue'
  export default {
    components: {
      LxmTag
    },
    props: {
      rows: Array,
      panelStyle: Object,
      panelBlockStyle: Object,
      valueStyle: String,
      newLineStyle: String
    },
    methods: {
      spanStyle (row) {
        if (this.valueStyle) {
          // 总宽度
          let totalWidth = 0
          if (document.querySelector('#contact-base .media')) {
            totalWidth = document.querySelector('#contact-base .media').offsetWidth
          } else {
            totalWidth = document.getElementsByClassName('is-clearfix')[document.getElementsByClassName('is-clearfix').length - 1].offsetWidth
          }

          // key长度
          const htmlKey = document.createElement('span')
          // lxm-panel__left-text
          htmlKey.className = 'lxm-panel__left-text'
          htmlKey.id = 'getTextWidth'
          htmlKey.innerText = row.key.text
          document.querySelector('body').appendChild(htmlKey)
          const widthKey = document.querySelector('#getTextWidth').offsetWidth
          document.querySelector('#getTextWidth').remove()

          // value长度
          const htmlValue = document.createElement('span')
          htmlValue.className = 'lxm-panel__value is-pulled-right has-text-right'
          htmlValue.style = 'width: auto;text-align: -webkit-auto;'

          if (row.value instanceof Array) {
            htmlValue.innerText = row.value.join(',')
          } else {
            htmlValue.innerText = row.value
          }

          htmlValue.id = 'getTextWidth'
          document.querySelector('body').appendChild(htmlValue)
          const widthValue = document.querySelector('#getTextWidth').offsetWidth
          document.querySelector('#getTextWidth').remove()

          if (widthKey + widthValue + 10 >= totalWidth) {
            return this.valueStyle + this.newLineStyle
          } else {
            return this.valueStyle
          }
        }

        return ''
      },
      valueContent (row) {
        if (row.value instanceof Array) {
          return row.value.join(',')
        }

        return row.value
      },
      rowClicked (row) {
        if (row.clicked && !row.loading) {
          row.clicked()
        }
        if (row.href) {
          window.open(row.href)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmPanel.vue?b440be68